module.exports = __webpack_public_path__ + "static/img/townsend2.69666bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/townsend2.jpg
// module id = nl2U
// module chunks = 1